export class ListUtils {

    public static findInListByCode(_code: string, _liste: any[]): any {
        return _liste.find((val) => {
            return val.code === _code;
        });
    }

}